// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__3M8EF","mainSec":"main_mainSec__1tihO","chanllangebar":"main_chanllangebar__3zol8"};